var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { VoucherStatus } from '@daredrop-com/rewards-api-contract';
import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { useCreatorGiveawayRewards } from 'root/src/client/v2/_pages/creator/redesign/useCreatorGiveawayRewards';
const STALE_TIME_MS = 1000 * 15;
// Redesign data layer for the giveaway-winner redeem flow. The legacy `useReedemModal` reached for
// Redux (`useGiveawayApi` / `useCreatorDataApi` thunks). Here the available vouchers are read through the
// v2 fetcher (GET_USER_VOUCHERS, scoped to this creator/owner with the viewer as the participant), the
// reward pool reuses `useCreatorGiveawayRewards` (GET_USER_GIVEAWAY_REWARDS), and a redeem hits
// REDEEM_REWARD. Redeemed reward ids are tracked locally so the winner sees claimed state immediately.
export const useCreatorGiveawayRedeem = (creatorUserId, creatorMnemonicId) => {
    var _a;
    const { fetcher } = useDareDropApi();
    const { rewards } = useCreatorGiveawayRewards(creatorUserId, creatorMnemonicId);
    const [redeemedRewardIds, setRedeemedRewardIds] = useState([]);
    const vouchersQuery = useQuery({
        queryKey: ['creator-giveaway-vouchers', creatorUserId],
        queryFn: () => fetcher({
            endpointId: giveawayEndpointIds.GET_USER_VOUCHERS,
            payload: { userId: creatorUserId, status: VoucherStatus.Available },
        }, true),
        enabled: Boolean(creatorUserId),
        staleTime: STALE_TIME_MS,
    });
    const vouchers = (_a = vouchersQuery.data) !== null && _a !== void 0 ? _a : [];
    const totalVouchers = vouchers.length + redeemedRewardIds.length;
    const redeem = (reward) => __awaiter(void 0, void 0, void 0, function* () {
        const voucher = vouchers[0];
        if (!voucher) {
            throw new Error('No vouchers left, please try again later.');
        }
        yield fetcher({
            endpointId: giveawayEndpointIds.REDEEM_REWARD,
            payload: { rewardId: reward.fullId, voucherId: voucher.id },
        }, true);
        setRedeemedRewardIds(prev => [...prev, reward.id]);
        yield vouchersQuery.refetch();
    });
    return {
        rewards,
        vouchers,
        totalVouchers,
        redeemedRewardIds,
        isLoading: vouchersQuery.isLoading,
        redeem,
    };
};
